import { PromptOption } from '../types/prompt';
import { API_ENDPOINT } from '../config';


export const getPromptOptions = async (): Promise<PromptOption[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await fetch(`${API_ENDPOINT.promptUrl}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch prompt options');
  }

  return response.json();
};